import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router-dom";

function Beneficiary(props) {

    const columns = [
        { name: "إسم المستفيد", key: "name" },
        { name: " تاريخ الميلاد", key: "dateofbirth" },
        { name: "النوع", key: "gender_string" },
        { name: "الحالة", key: "status_string" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState([]);
    const navigate = useNavigate();

    const getHumanCases = async () => {
        try {
            const res = await API.post("/humancases");
            const data = await res;
            if (data.status === 200) {
                setRows(data.data);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setError(error.response.data.errors);
        }
    };
    useEffect(() => {
        getHumanCases();
    }, []);
    const dropdownOptions = [
        { label: "تعديل", route: "/editbeneficiary/:id" },
        { label: "دراسة حالة", route: "/casestudy/:id" },
        { label: "البيانات البنكية", route: "/BankData/:id" },
        { label: "المؤهل و الوظيفية", route: "/QualificationPosition/:id" },
        { label: "بيانات السكن", route: "/HousingData/:id" },
        { label: "البيانات الصحية", route: "/ShowhealthData/:id" },
        { label: "بيانات التابعين ", route: "/showDependentsData/:id" },
        {
            label: " سند دفع ", action: (id) => {
                if (rows.find((row) => row.id === id).status_string !== "موافقة") {
                    alert("لا يمكن عرض السند حتى تتم الموافقة على المستفيد");
                } else {
                    navigate(`/paymentvoucherGeneral/${id}`)
                }
            }
        },

    ];


    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // useEffect(() => {
    //     getHumanCases();
    // }, []);

    return (

        <>
            <div className="printcasedata-container">



                <TableComponent
                    apiUrl="/humancases"
                    columns={columns}
                    title="تقرير المستفيدين"
                    titleIcon={<FontAwesomeIcon icon={faReceipt} />}
                    dropdownOptions={dropdownOptions}
                />
            </div>
        </>
    );
}

export default Beneficiary;
